import { AwardTypes } from '../../../constants/CourseConstants';
import SkeletonThumbnail from './SkeletonThumbnail';
import { useTrack, useTrackProgressTime } from '../../../features/tracks';
import ThumbnailOverlayed from './ThumbnailOverlayed';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { OLAF, LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import TrackViewAwardLink from '../TrackViewAwardLink';
import { useAssetStatus, useTrackAwardProgress } from '../../../features/userProgress';
import { FILTER_CONSTS } from '../../../constants/TopFilterConstants';
import { CardMenuIcon } from '../../../features/cardMenu';
import { TrackCardTimeReadout } from '../TrackCardTimeReadout';
import { useTrackDisplayCategories } from '../../../features/categories';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoWrapTrackViewAwardLink = styled(TrackViewAwardLink).withConfig({
  displayName: "TrackThumbnailOverlayed__NoWrapTrackViewAwardLink",
  componentId: "sc-1bhitny-0"
})(["white-space:nowrap;margin-left:18px;margin-bottom:1px;"]);
const CertIcon = styled(UIIcon).withConfig({
  displayName: "TrackThumbnailOverlayed__CertIcon",
  componentId: "sc-1bhitny-1"
})(["top:1px;position:relative;"]);
const CertificateBadge = ({
  isGhost
}) => {
  return /*#__PURE__*/_jsx(CertIcon, {
    color: isGhost ? OLAF : LORAX,
    name: "certification",
    size: 15,
    style: {
      opacity: isGhost ? 0.5 : 1
    }
  });
};
const TrackThumbnailOverlayed = ({
  trackId,
  isGhost,
  language,
  headerIcons = /*#__PURE__*/_jsx(CardMenuIcon, {
    language: language,
    trackId: trackId,
    use: "on-dark"
  })
}) => {
  const {
    award
  } = useTrackAwardProgress(trackId);
  const {
    track
  } = useTrack(trackId, language);
  const {
    status
  } = useAssetStatus({
    id: Number(trackId),
    type: 'TRACK'
  });
  const completed = status === FILTER_CONSTS.STATUSES.COMPLETED;
  const {
    trackDisplayCategories
  } = useTrackDisplayCategories({
    trackId
  });
  const {
    remainingTime,
    totalTime
  } = useTrackProgressTime(trackId);
  if (!track) {
    return /*#__PURE__*/_jsx(SkeletonThumbnail, {});
  }
  const {
    certification,
    deprecated,
    previewThumbnailRectangleUrl
  } = track;
  const certAwardType = certification ? AwardTypes.BADGE_AND_CERTIFICATE : AwardTypes.CERTIFICATE_OF_COMPLETION;
  return /*#__PURE__*/_jsx(ThumbnailOverlayed, {
    categories: trackDisplayCategories || [],
    completed: completed,
    header: certification && /*#__PURE__*/_jsx(CertificateBadge, {
      isGhost: isGhost || deprecated
    }),
    headerIcons: headerIcons,
    isGhost: isGhost || deprecated,
    previewThumbnailRectangleUrl: previewThumbnailRectangleUrl || undefined,
    remainingTime: remainingTime,
    thumbnailFooter: /*#__PURE__*/_jsxs(_Fragment, {
      children: [!completed && /*#__PURE__*/_jsx(TrackCardTimeReadout, {
        trackId: trackId
      }), /*#__PURE__*/_jsx(UIBox, {
        style: {
          marginTop: '-3px'
        },
        children: !!certification && award && !award.isExpired && /*#__PURE__*/_jsx(NoWrapTrackViewAwardLink, {
          award: award,
          certification: certification,
          className: `track-card-simple__view-cert`,
          likeLink: true,
          size: 'small',
          trackId: trackId,
          use: 'on-dark',
          useButton: false
        })
      })]
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: certification ? `learningCenter.awards.${certAwardType}` : 'learningCenter.resources.type.TRACK'
    }),
    totalTime: totalTime
  });
};
export default TrackThumbnailOverlayed;